import {
  searchPages,
  fetchAllManuals,
  performSearch,
} from '../utils/searchFiles';

export default (node) => {
  const tabType = node.dataset.tab;
  const searchInput = node.getAttribute('data-search-input');
  let allManuals = [];

  const init = async () => {
    allManuals = await fetchAllManuals();

    if (tabType === 'page') {
      const container = document.createElement('div');
      const containerInner = document.createElement('div');
      containerInner.classList.add(
        'p-4',
        'flex',
        'flex-col',
        'items-start',
        'justify-start',
        'gap-4'
      );
      containerInner.innerHTML = await searchPages(searchInput);
      container.appendChild(containerInner);
      node.innerHTML = container.innerHTML;
    }
    if (tabType === 'assembly') {
      const container = document.createElement('div');
      const containerInner = document.createElement('div');
      containerInner.classList.add(
        'p-4',
        'flex',
        'flex-col',
        'items-start',
        'justify-start',
        'gap-4',
        '[&>div]:ml-12'
      );
      const temp = await performSearch(allManuals, searchInput);
      containerInner.innerHTML = temp.innerHTML;
      container.appendChild(containerInner);
      node.innerHTML = container.innerHTML;
    }
  };

  init();
};
